import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface WeightProps {
  color?: string;
  height?: string;
  width?: string;
  style?: React.CSSProperties;
}

export default function Weight({
  color = RoutalPalette.primary40,
  height = `18px`,
  width = `18px`,
  style = {},
}: WeightProps) {
  return (
    <SvgIcon viewBox="0 0 18 18" style={{ width, height, fill: `none`, ...style }}>
      <path
        d="M2.3606 5.96975C2.37716 5.84554 2.4831 5.75278 2.6084 5.75278H15.6122C15.7392 5.75278 15.846 5.84802 15.8605 5.97419L16.6056 5.88841L15.8605 5.97419L17.1266 16.9714C17.1437 17.1198 17.0277 17.25 16.8783 17.25H1.14218C0.990979 17.25 0.874387 17.1168 0.894369 16.967L2.3606 5.96975Z"
        fill={color}
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M11.3132 3.03665C11.3132 4.30528 10.2947 5.32329 9.05114 5.32329C7.80756 5.32329 6.78906 4.30528 6.78906 3.03665C6.78906 1.76801 7.80756 0.75 9.05114 0.75C10.2947 0.75 11.3132 1.76801 11.3132 3.03665Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </SvgIcon>
  );
}
